@if (channel?.subscriblyChannel) {
  <a
    class="channel-avatar-wrapper"
    [href]="channel?.subscriblyChannel?.URL"
    target="_blank"
  >
    @if (channel?.subscriblyChannel?.avatarURL) {
      <img
        class="channel-avatar {{ size }}"
        [src]="channel?.subscriblyChannel?.avatarURL"
        alt=""
      />
    } @else {
      <div class="channel-avatar channel-avatar-placeholder {{ size }}">
        <span>{{ channel?.subscriblyChannel?.name?.charAt(0) }}</span>
      </div>
    }

    <ly-icon
      *ngIf="badge"
      class="{{ channel?.platform }} {{ size }}"
      [icon]="channel?.platform"
      alt=""
    ></ly-icon>
  </a>
} @else {
  <ly-icon
    *ngIf="badge"
    class="{{ channel?.platform }}"
    [icon]="channel?.platform"
    alt=""
  ></ly-icon>
}
